import { types } from 'mobx-state-tree';

import { Employment as BaseEmployment } from '../definitions/common';


const CreditCardEmployment = types.model('CreditCardEmployment', {
    // jobStatus vary from applications therefore cannot use generic employment enum
    jobStatus: types.maybe(types.string),
    phone: types.maybe(types.string),

    // National Bank Specific
    employmentDuration: types.maybe(types.string), // @TODO: Rename to occupationDuration
    studentType: types.maybe(types.string),
});

const Employment = types.compose('Employment', BaseEmployment, CreditCardEmployment);

export default Employment;
